import { Tab, TabContext, TabList } from '@shared/components';

import { type ExamLocationRequestStatus } from '../../constant';
import { useAdminExamLocationRequestListSearchParams } from '../../hooks';

const TAB_ITEMS: { value: ExamLocationRequestStatus; label: string }[] = [
  {
    value: 'IN_REVIEW',
    label: 'อยู่ระหว่างอนุมัติ',
  },
  {
    value: 'REJECTED',
    label: 'ไม่อนุมัติ',
  },
];

export default function AdminExamLocationRequestListNavigationTabs() {
  const [{ status }, { changeStatus }] = useAdminExamLocationRequestListSearchParams();

  const handleClick = (value: ExamLocationRequestStatus) => {
    changeStatus(value);
  };

  return (
    <TabContext value={status}>
      <TabList
        sx={(theme) => ({
          p: theme.spacing(4, 4, 0, 4),
        })}
      >
        {TAB_ITEMS.map((tab) => {
          return (
            <Tab
              key={tab.value}
              label={tab.label}
              value={tab.value}
              onClick={() => handleClick(tab.value)}
              sx={{
                minWidth: 'unset',
              }}
            />
          );
        })}
      </TabList>
    </TabContext>
  );
}
